import React, { useState, useEffect, useRef } from 'react'
import { 
    Layout,
    Col, 
    Row,
    Image,
    Button,
    Space,
    Table,
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar';
// import HeaderImage from '../../Assets/Images/CPM-HEADER-cropped-1.png'
import html2canvas from 'html2canvas';
import jsPDF from "jspdf";
// import TenantSignature from "../../Assets/Images/tenant_signature.png"
// import OwnerSignature from "../../Assets/Images/owner_signature.png"

import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { useReactToPrint } from "react-to-print";
import { capitalizeText, formatAmount, formatDate, refreshPage, extractDateTime } from '../../Utils/Common';
import { 
    ProductOutlined,
} from '@ant-design/icons';
import { SeeAttachment } from '../../Components/SeeAttachment';
import { PreviewTable } from '../../Components/PreviewTable';

const PreviewExpense = () => {
    const navigate = useNavigate()
    const currentDate = new Date();
    const { id, form } = useParams();
    const expense_form = {
        unit: {
          header1: 'EXPENSE SLIP',
          get: 'expenses/get',
          print: 'emails/send_expense',
        },
        parking: {
         
          header1: 'PARKING EXPENSE SLIP',
          get: 'parking_expenses/get',
          print: 'emails/send_parking_expense',
        }
      };
    const [newAttachment, setNewAttachment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [soaData, setSoaData] = useState([])

    const { callPost, loading } = usePostRequest(()=>{
        refreshPage()
    });

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;


    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const columns = [
        {
            title: 'Items',
            dataIndex: 'item',
            key: 'item',
            align: 'center'
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (amount) => formatAmount(amount)
        }
    ];
    const columns3 = [
        {
          title: 'Date Added',
          dataIndex: 'added_on',
          key: 'added_on',
          width: '30%',
          render: (amount) => formatDate(amount),
        },
        {
          title: 'Attachments',
          dataIndex: 'link',
          key: 'link',
        },
    ];  

    const handleSendEmail = async (ref) => {
        if (ref) {
            const element = document.getElementById(ref);
    
            html2canvas(element, { scale: 2 }).then(async (canvas) => {
                const scale = 0.7; // Set the desired scale (70%)
    
                // Create a new canvas with scaled dimensions
                const scaledCanvas = document.createElement('canvas');
                const context = scaledCanvas.getContext('2d');
                scaledCanvas.width = canvas.width * scale;
                scaledCanvas.height = canvas.height * scale;
    
                // Draw the original canvas onto the scaled canvas
                context.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scaledCanvas.width, scaledCanvas.height);
    
                // Convert the scaled canvas to an image
                const imgData = scaledCanvas.toDataURL('image/jpeg', 1);
    
                const pdf = new jsPDF();
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = scaledCanvas.width;
                const imgHeight = scaledCanvas.height;
    
                // Calculate the ratio needed to fit the image within the PDF dimensions
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    
                // Calculate the new width and height of the image
                const newWidth = imgWidth * ratio;
                const newHeight = imgHeight * ratio;
    
                // Center the image in the PDF
                const imgX = (pdfWidth - newWidth) / 2;
                const imgY = 0;
    
                // Add the image to the PDF
                pdf.addImage(imgData, 'JPEG', imgX, imgY, newWidth, newHeight); // Use 'JPEG' format for better compression
                pdf.save(`Expense_${extractDateTime(currentDate)}.pdf`);
    
                // Convert the pdf file from Blob to File obj (needed for upload API)
                const blobPdf = pdf.output('blob');
                const formPdf = new File([blobPdf], `Expense_${extractDateTime(currentDate)}.pdf`, {
                    type: blobPdf.type,
                });
                
                let file = [];
                
                if(newAttachment){
                    file = newAttachment.map((data) => {
                        return data?.file_url
                    });
                }
                
                const finalValues = Object.entries({ expense_id: id, attachment: formPdf, additional_attachments: file,  filename: `Expense_${extractDateTime(currentDate)}.pdf` }).map(([key, value]) => ({
                    key,
                    value,
                }));
    
                callPost(expense_form[form].print, finalValues, true);
            });
        }
    };


    async function fetchSOAData  () {
        setIsLoading(true)
        const response = await UseGetRequest(expense_form[form].get, {expense_id: id});
        if (response?.data) {
            let attachment = response?.data?.data[0]?.attachments?.map((file) => ({
            ...file,
            link: (
                <SeeAttachment
                attachments={[
                    { file_url: file.file_url, file_name: file.file_name },
                ]}
                />
            ),
            })) 
            setNewAttachment(attachment)
            setSoaData(response?.data?.data[0]);
        } else {
            setSoaData([])
        }
        setIsLoading(false);
    }
    useEffect(() => {
        fetchSOAData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Layout className='page'>
            <Navbar navKey={'property'}/>
            <Layout className='content-container content-container-print overflow-y'>
                <Row className='m-4 paper-view'>
                    <Col className='email-pad print-content' id="preview" ref={componentRef}>
                        <Row className='mb-5'>
                            <Col span={24} align="center">
                                <Image
                                    width='100%'
                                    height="90%"
                                    src={window.form_header}
                                    alt="login-image"
                                    preview={false}
                                />
                            </Col>
                        </Row>
                        <Row className='center mb-2'>
                            <Col className='divider-text'>
                                {expense_form[form].header1}
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={15} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Supplier Name :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {soaData?.supplier_name}
                                    </div>
                                </Space>
                            </Col>
                            {
                                soaData?.type !== "internal" && (
                                    <Col span={9} align="left">
                                        <Space>
                                            <div className='text-sm'>
                                                Name :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {soaData?.trade_name}
                                            </div>
                                        </Space>
                                    </Col>
                                )
                            }
                        </Row>
                        <Row className='mb-2'>
                            <Col span={15} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Description :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {soaData?.description}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={9} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Type :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {capitalizeText(soaData?.type)}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={15} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Property :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {soaData?.property_name}
                                    </div>
                                </Space>
                            </Col>
                            {
                                form === 'unit' ? (
                                    <Col span={9} align="left">
                                        <Space>
                                            <div className='text-sm'>
                                                Unit Number :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {soaData?.rental_unit_name}
                                            </div>
                                        </Space>
                                    </Col>
                                ) : (
                                    <Col span={9} align="left">
                                        <Space>
                                            <div className='text-sm'>
                                                Parking Unit Number :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {soaData?.parking_unit_name}
                                            </div>
                                        </Space>
                                    </Col>
                                )
                            }
                        </Row>
                        <Row className='mb-4'>
                            <Col span={15} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Expense Date :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {formatDate(soaData?.expense_date)}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table'>
                                {/* <Table
                                    dataSource={soaData.items}
                                    columns={columns}
                                    rowKey="id"
                                    pagination={false}
                                /> */}
                                <PreviewTable
                                    dataSource={soaData.items}
                                    columns={columns}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2' align='end'>
                                <Space className='amount-total'>
                                    <div className='p-2'>
                                        Total Amount Due
                                    </div>
                                    <div className='p-2'>
                                        {formatAmount(soaData?.total)}
                                    </div>
                                </Space>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}  className='p-2' align='start'>
                                <Space>
                                    <div>
                                        Remarks :
                                    </div>
                                    <div>
                                        {soaData?.remarks}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                           
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2'>
                                 <Row>
                                    <Col className='text-sm'>
                                        Please make checks payable to:
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm mb-2'>
                                        {window.system_title}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account1}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account2}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm mb-2'>
                                        {window.account3}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account4}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm'>
                                        {window.account5}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='check-row text-sm mb-2'>
                                        {window.account6}
                                    </Col>
                                </Row>
                                <Row className='my-5 text-sm'>
                                    <Col>
                                        Please advise if any payment made is not reflected in this statement.
                                    </Col>
                                </Row>
                                <Row className='my-4'>
                                    <Col align='left text-sm'>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            {/* {
                                                soaData?.type === "owner" ? (
                                                    <img
                                                    src={OwnerSignature}
                                                    alt="Owner Signature"
                                                    style={{height:'10vh', width: 'auto' }}
                                                    />
                                                ) : (
                                                    <img
                                                    src={TenantSignature}
                                                    alt="Tenant Signature"
                                                    style={{height:'10vh', width: 'auto' }}
                                                    />
                                                )
                                            } */}
                                            <div style={{ borderTop: '1px solid black', width: '150%', marginTop: '0', marginBottom: '0' }}></div>
                                            <div>Prepared By,</div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    {
                                        soaData?.type === "tenant" ? (
                                        
                                                <Col className='text-sm'>
                                                    <Row>{window.tenant_signatories}</Row>
                                                    <Row>AMBRE Property Partners</Row>
                                                </Col>
                                        ) : (
                                                <Col className='text-sm'>
                                                    <Row>{window.owner_signatories}</Row>
                                                    <Row>Billing and Collection</Row>
                                                </Col>
                                        )
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='btn-footer'>
                    <Space className='mb-4 me-4'>
                        <Button
                            onClick={() => navigate(-1)}
                            className='cancel-color btn-header'
                        >
                            Cancel
                        </Button>
                   
                  {
                    soaData.type !== "internal" && (
                      
                            <Button
                            onClick={() => handleSendEmail('preview')}
                            className='secondary-btn btn-header'
                            loading={loading}

                            >
                                Send to Email
                            </Button>
                       
                    )
                  }
                   
                        <Button
                            onClick={handlePrint}
                            type='primary'
                            className='btn-header'
                        >
                            Print
                        </Button>
                    </Space>
                </Row>
                <Row className='mx-4'>
                    <Col span={24}>
                        <Table 
                            columns={columns3} 
                            dataSource={newAttachment} 
                            pagination={false}
                            loading={{
                                indicator: customSpinner,
                                spinning: isLoading,
                            }}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default PreviewExpense
